import React from 'react';
import DashBoardHeader from '../header_dashboard/dashboard_header';
import './account.less';
import {Link, browserHistory} from 'react-router';
import ProfileNavBar from './profile_navbar/profile_navbar';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {routerActions} from 'react-router-redux';
import Rating from '../components/rating/rating';
import MediaQuery from 'react-responsive';
import profileActions from './profile_actions';
import LoggedinFooter from '../footer/loggedin_footer';
import moment from 'moment';
import authActions from '../auth/auth_actions';
import cookies from '../util/cookie';
import CONSTANTS from '../common_constants';
import ShowError from '../components/error/show_error';
import LogoutPopUp from '../components/logoutPopUp/logout_pop_up';
import UserReviewThread from '../components/user_review_thread/user_review_thread.jsx';

class Profile extends React.Component {

    constructor(props) {
        super(props);
        this.profileReview = this.profileReview.bind(this);
        this.viewProfile = this.viewProfile.bind(this);
        this.reviewPagination = this.reviewPagination.bind(this);
        this.paginate = this.paginate.bind(this);
        this.arrayObjectExtract = this.arrayObjectExtract.bind(this);
        this.state= {
            offsetIncrement: 5,
            offset: 0,
            totalCount: 5,
            count: 5,
            ajaxInProgress: false,
        }

        this.logout = this.logout.bind(this);
    }

    logout(){
        this.props.authActions.logout().always(() => {
            cookies.delete('_sd');
            document.location.href = '/';
        });
    }

    profileReview(reviewArr){
       let totalReview = [];
       if(reviewArr.length > 0){
           reviewArr.map((reviewObj, index) => {
               totalReview.push(<UserReviewThread key={index} backTo={'profile'} reviewObj = {reviewObj}/>);
            })
           return totalReview;
       }
       return [];
    }

    viewProfile(){
        this.setState({ajaxInProgress: true});
        let {profileActions} = this.props;
        let {userId} = this.props.authState.userData;
        let url_params = {encryptedUserId: userId}
        let totalNoOfRatings;

        profileActions.viewProfile(url_params).then( (successData) => {
            totalNoOfRatings =  successData.totalNoOfRatings;

            this.setState({
              totalCount: totalNoOfRatings,
              ajaxInProgress: false
            });
        },(errorRes) => {
          if(errorRes.error === CONSTANTS.sessionInvalid){
            this.setState({isLoading: false,ajaxInProgress: false});
                this.props.authActions.sessionValid(false);
                cookies.delete('_sd');
                return ;
          }
          this.setState({
            ajaxInProgress: false,
            error: errorRes.error
          });
        })
    }

    paginate(pageObj){

        if(pageObj.offset > pageObj.totalCount){
            return pageObj.offset
        }
        else{
            return pageObj.offset + pageObj.offsetIncrement;
        }
    }

    arrayObjectExtract(toArray, fromArray){
    // array push creates array of arrays
    // but not array of objects. This func is used
    // for that purpose
    // toArray to which objects needs to be pushed
    // fromArray from which objects needs to be fetched

      fromArray.forEach( (reviewObj) => {
          toArray.push(reviewObj);
      })
         return toArray;
    }


    reviewPagination(){
        const {state} = this;
        let {profileActions} = this.props;
        let {userId} = this.props.authState.userData;
        let {offsetIncrement} = state;
        let {offset} = state;
        let {count} = state;
        let {totalCount} = state;
        let pageObj = {
           offsetIncrement: offsetIncrement,
           offset: offset,
           totalCount: totalCount
       };


        let url_params = {
            encryptedUserId: userId,
            offset: offset,
            count: count
        }
        this.setState({
            ajaxInProgress: true
        });
        profileActions.getProfileReviews(url_params).then( () => {
            offset = this.paginate(pageObj);
            this.setState({
                offset: offset,
                ajaxInProgress: false
            })

        },(errorRes) => {
          if (errorRes.error === CONSTANTS.sessionInvalid) {
              this.setState({isLoading: false});
                  this.props.authActions.sessionValid(false);
                  cookies.delete('_sd');
                  return ;
          }
            this.setState({
             ajaxInProgress: false
            });
        })
    }


    componentDidMount(){
      const {props} = this;
          this.setState({
              ajaxInProgress: true
          })
         this.viewProfile();
          if(props.profile.reviews.length == 0){
            // call api only once
            // sort of caching
            this.setState({
                ajaxInProgress: true
            })
             this.reviewPagination();
         }

    }

    render() {
       const {props, state} = this;
       const self = this;
       let {userData} = props.authState;
       let {profileInfo} = props.profile;
       let paginatedReview = props.profile.reviews;
       let currReview = [];
       let userReviewArr = [];
       let {averageRating}= profileInfo;
       let totalRatings = profileInfo.totalNoOfRatings;
       let {date} = profileInfo;
       let joinedDate;
       let {isVerified} = profileInfo;
       let userReviewsComplete;
       let enableLoadMore = false;
       let reviewsLength = props.profile.reviewsLength;
       let sessionValid = true ;
       if("sessionValid" in props.authState.userData)
           sessionValid = props.authState.userData.sessionValid;
       (date) ? joinedDate =  moment.unix(date/1000).format("MMM  YYYY") : joinedDate = '';

       (paginatedReview && paginatedReview.length > 0) ? (currReview = this.arrayObjectExtract(currReview, paginatedReview)) : (currReview = []);

       if(currReview && currReview.length ){
           (currReview.length  < state.totalCount && currReview.length > 4) ? enableLoadMore = true : enableLoadMore = false;
       }

       let user = {
         name: '',
         imageUrl: '',
         isVerified: '',
         creditAmount: ''
       };

       if(props.authState) {
         user.name = userData.name;
         user.imageUrl = userData.profileImageUrl;
         user.isVerified = userData.isVerified;
         user.creditAmount = userData.creditAmount
       }

       user.imageUrl = userData.profileImageUrl || "../../public/images/user_placeholder.svg";
       (paginatedReview && paginatedReview.length  > 0 ) ? (userReviewArr = this.profileReview(currReview)) : (userReviewArr = []);

        return (
                <div className="profile-details-wrap">
                    <LogoutPopUp isOpen={!sessionValid}></LogoutPopUp>
                  {state.error && <ShowError errorMessage={state.error}/>}
                  <DashBoardHeader user={user} logout={this.logout} />
                    <div className="profile-header-wrap">
                        <div className="wrapper">
                            <h2 className="page-header profile-page-header">Account</h2>
                        </div>
                    </div>
                    {state.ajaxInProgress && <div className = "loader-wrapper"><div className = "loader"></div></div>}
                    <div id="profileViewWrap">
                        <div className="wrapper" id="profileView">
                            <ProfileNavBar pathname={this.props.location.pathname} userData={user}/>
                            <div className="profile-view-wrap">
                                <div className="user-profile-details-wrp">
                                    <div className="user-profile-img-wrp">
                                        <img className="user-profile-img-elm" src={user.imageUrl} />
                                    </div>
                                    <div className="user-profile-details">
                                        <div className="user-profile-name">{userData.name}</div>
                                         { isVerified && <div className="user-profile-verified-wrp">
                                             <div className="profile-verified-img-elm"></div><span className="user-profile-verified">Verified</span>
                                         </div>}
                                        <div className="user-profile-rating-wrp" >
                                        <Rating  rating = {averageRating} ratingSize="rating-size10" /><span id="totalRating">({totalRatings})</span>
                                        </div>
                                        <div className="user-profile-date">Joined {joinedDate}</div>
                                    </div>
                                </div>
                                <div className="review-group-wrp">
                                   {userReviewArr && userReviewArr.length>1 && <div className="review-title">Reviews</div>}
                                  <div>{userReviewArr}</div>
                                  {userReviewArr.length == 0 && <div className="no-reviews">No Reviews</div>}
                                </div>
                                {enableLoadMore && <div className="profile-pagination-wrap" onClick={this.reviewPagination.bind(self)} >
                                    Load More
                                </div>}
                            </div>
                        </div>
                    </div>
                <LoggedinFooter />
                </div>
            )
    }
}

Profile = connect((state) => {
  return {
    authState: state.app.auth,
    profile: state.app.profile
  }
}, (dispatch) => {
  return {
    routerActions: bindActionCreators(routerActions, dispatch),
    profileActions: bindActionCreators(profileActions, dispatch),
    authActions : bindActionCreators(authActions, dispatch),
  }
})(Profile);

module.exports = Profile;



// WEBPACK FOOTER //
// app/profile/profile.jsx